export const PVC_STANDARD_PRODUCTION_DAYS = 5;
export const PVC_RUSH_PRODUCTION_DAYS = 1;

const hebrewCalendar = new Intl.DateTimeFormat("en-US-u-ca-hebrew", {
  timeZone: "UTC", year: "numeric", month: "long", day: "numeric",
});

function dateOnly(value: Date): string {
  return value.toISOString().slice(0, 10);
}

export function todayInIsrael(now: Date = new Date()): string {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "Asia/Jerusalem", year: "numeric", month: "2-digit", day: "2-digit",
  }).formatToParts(now);
  const part = (type: string) => parts.find(item => item.type === type)?.value;
  return `${part("year")}-${part("month")}-${part("day")}`;
}

export function tomorrowInIsrael(now: Date = new Date()): string {
  const date = new Date(`${todayInIsrael(now)}T12:00:00.000Z`);
  date.setUTCDate(date.getUTCDate() + 1);
  return dateOnly(date);
}

export function isIsraeliProductionDay(value: string): boolean {
  const date = new Date(`${value}T12:00:00.000Z`);
  if (date.getUTCDay() === 6) return false;
  const parts = hebrewCalendar.formatToParts(date);
  const month = parts.find(part => part.type === "month")?.value;
  const day = Number(parts.find(part => part.type === "day")?.value);
  if (!month || !Number.isInteger(day)) throw new Error("Could not resolve Hebrew calendar date");
  if (month === "Tishri" || month === "Tishrei") {
    return ![1, 2, 10, 15, 22].includes(day);
  }
  if (month === "Nisan") return day !== 15 && day !== 21;
  if (month === "Sivan") return day !== 6;
  if (month === "Iyar" && day >= 3 && day <= 6) {
    const fifthIyar = new Date(date);
    fifthIyar.setUTCDate(fifthIyar.getUTCDate() + 5 - day);
    const observedDay = fifthIyar.getUTCDay() === 5 ? 4
      : fifthIyar.getUTCDay() === 6 ? 3
        : fifthIyar.getUTCDay() === 1 ? 6 : 5;
    return day !== observedDay;
  }
  return true;
}

export function addIsraeliProductionDays(startDate: string, days: number): string {
  const date = new Date(`${startDate}T12:00:00.000Z`);
  for (let remaining = days; remaining > 0;) {
    date.setUTCDate(date.getUTCDate() + 1);
    if (isIsraeliProductionDay(dateOnly(date))) remaining -= 1;
  }
  return dateOnly(date);
}
